export enum FeatureFlag {
    GUEST_PORTAL_MOBILE_APP = 'guests-my-trips-download-app-mobile'
}

export interface FeatureDecisionResult<T> {
    isEnabled: boolean;
    config: T | null;
    clientReady: boolean;
}